// 2024 image
import set from "../assets/images/event image/2024/2-3 set/sat (1).webp";
import set1 from "../assets/images/event image/2024/2-3 set/sat (2).webp";
import set2 from "../assets/images/event image/2024/2-3 set/sat (3).webp";
import set3 from "../assets/images/event image/2024/2-3 set/sat (4).webp";
import set4 from "../assets/images/event image/2024/2-3 set/sat (5).webp";
import set5 from "../assets/images/event image/2024/2-3 set/sat (6).webp";
import set6 from "../assets/images/event image/2024/2-3 set/sat (7).webp";
import set7 from "../assets/images/event image/2024/2-3 set/sat (8).webp";
import set8 from "../assets/images/event image/2024/2-3 set/sat (9).webp";
import set9 from "../assets/images/event image/2024/2-3 set/sat (10).webp";
// february
import feb from "../assets/images/event image/2024/8-9 feb/feb (1).webp";
import feb1 from "../assets/images/event image/2024/8-9 feb/feb (2).webp";
import feb2 from "../assets/images/event image/2024/8-9 feb/feb (3).webp";
import feb3 from "../assets/images/event image/2024/8-9 feb/feb (4).webp";
import feb4 from "../assets/images/event image/2024/8-9 feb/feb (5).webp";
import feb5 from "../assets/images/event image/2024/8-9 feb/feb (6).webp";
import feb6 from "../assets/images/event image/2024/8-9 feb/feb (7).webp";
import feb7 from "../assets/images/event image/2024/8-9 feb/feb (8).webp";
import feb8 from "../assets/images/event image/2024/8-9 feb/feb (9).webp";
// aust
import aug from "../assets/images/event image/2024/29-30 aug/aug (1).webp";
import aug1 from "../assets/images/event image/2024/29-30 aug/aug (2).webp";
import aug2 from "../assets/images/event image/2024/29-30 aug/aug (3).webp";
import aug3 from "../assets/images/event image/2024/29-30 aug/aug (4).webp";

// 2025 
import jul1 from "../assets/images/event image/2025/day1/d1 (1).webp";
import jul2 from "../assets/images/event image/2025/day1/d1 (2).webp";
import jul3 from "../assets/images/event image/2025/day1/d1 (3).webp";
import jul4 from "../assets/images/event image/2025/day1/d1 (4).webp";
import jul5 from "../assets/images/event image/2025/day1/d1 (5).webp";
import jul6 from "../assets/images/event image/2025/day1/d1 (6).webp";
import jul7 from "../assets/images/event image/2025/day1/d1 (7).webp";
import jul8 from "../assets/images/event image/2025/day1/d1 (8).webp";

// julu 18 
import d2_1 from "../assets/images/event image/2025/day2/d2 (1).webp";
import d2_2 from "../assets/images/event image/2025/day2/d2 (2).webp";
import d2_3 from "../assets/images/event image/2025/day2/d2 (3).webp";
import d2_4 from "../assets/images/event image/2025/day2/d2 (4).webp";
import d2_5 from "../assets/images/event image/2025/day2/d2 (5).webp";
import d2_6 from "../assets/images/event image/2025/day2/d2 (6).webp";
import d2_7 from "../assets/images/event image/2025/day2/d2 (7).webp";
import d2_8 from "../assets/images/event image/2025/day2/d2 (8).webp";



export const accordionData = [
  //2025
  {
    id: 1,
    title: "Events 2025",
    details: "ICSCE, PMFAI, 2024 DUBAI",
    subsections: [
      {
        mt: "0px",
        subId: "17 July",

        role: "Showcasing Fenton Chemicals’ innovations while connecting with industry leaders.",
        subTitle: " Ahmedabad , Gujarat",
        images: [jul1,
          jul2,
          jul3,
          jul4,
          jul5,
          jul6,
          jul7,
          jul8],
      },
      {
        mt: "0px",
        subId: "18 July",
        role: "Showcasing Fenton Chemicals’ innovations while connecting with industry leaders.",
        subTitle: " Ahmedabad , Gujarat",
        images: [d2_1,
          d2_2,
          d2_3,
          d2_4,
          d2_5,
          d2_6,
          d2_7,
          d2_8,],
      },
      {
        mt: "0px",
        subId: "8-9 february",

        role: " The influence of optics in Lighting",
        subTitle: "ICSCE, PMFAI, DUBAI",
        images: [feb, feb1, feb2, feb3, feb4, feb5, feb6, feb7, feb8],
      },

    ],
  },
  {
    id: 1,
    title: "Events 2024",
    details: "ICSCE, PMFAI, 2024 DUBAI",
    subsections: [
      {
        subId: "29-30 August",
        role: "Talk by Solaange & Corrective Actions(In collaboration with IGBC)",
        subTitle: "IIAB, Hyderabad ",
        images: [set4, set5, set6, set7, set8, set9, aug2, aug3, aug, aug1,],
      },
      {
        subId: "2-3 September",
        role: "Talk by Solaange & Corrective Actions(In collaboration with IGBC)",
        subTitle: " ICSCE, PMFAI 2024 DELHI ",
        images: [set, set1, set2, set3, set4, set5, set6, set7, set8, set9],
      },
    ],
  },
];
